<template>
  <div class="page-container imitate-page ">
    <top-bar :title="i18n.t('imitate.title')"  @back="back"></top-bar>
    <div class="imitate-home" v-show="tabIndex == 1">
      <trade-page :modalType="modalType"></trade-page>
    </div>
    <div class="imitate-assets assest-main" v-show="tabIndex == 2">
      <div class="statistics-box">
        <div class="flex-center-start label">
          <span>{{i18n.t(`imitate.label1_${modalType}`)}}({{localCurrency}})</span>
          <img :src="showMoney ? eyeUrl2 : eyeUrl" alt="" @click="changeMoneyType">
        </div>

        <div class="flex-center-start money-info" >
          <div class="total flex-end-start">{{moneyStr}}</div>
          <div class="desc flex-end-start">≈ ${{showMoney ? resetBitMoney() : '****'}} </div>
        </div>


        <div class="flex today-static border">
          <div class="flex-1 flex-column-start-center">
            <div class="name">{{i18n.t(`imitate.label2`)}}({{localCurrency}})</div>
            <div class="count">0.00</div>
          </div>
          <div class="flex-1 flex-column-end-center">
            <div class="name">{{i18n.t(`imitate.label3`)}}({{localCurrency}})</div>
            <div class="count" >{{modalType == 1 ? optionMoneyUse : contractMoneyUse}}</div>
          </div>
        </div>
      </div>

      <div class="statistics-box small" v-if="modalType == 1">
        <div class="box-title">{{$t('account.label4')}}</div>
        <div class="flex today-static">
          <div class="flex-1 flex-column-start-center">
            <div class="name">{{$t('account.label5')}}({{bitName}})</div>
            <div class="count">{{optionReportData.TodayOptionOrder.Amount || '0.00'}}</div>
          </div>
          <div class="flex-1 flex-column-end-center">
            <div class="name">{{$t('account.label6')}}({{bitName}})</div>
            <div class="count" :class="optionReportData.TodayOptionOrder.Profit ? ( optionReportData.TodayOptionOrder.Profit > 0 ? 'green' : 'red') : ''">{{optionReportData.TodayOptionOrder.Profit || '0.00'}}</div>
          </div>
        </div>
      </div>

      <div class="statistics-box small" v-if="modalType == 1">
        <div class="box-title">{{$t('account.label7')}}</div>
        <div class="flex today-static">
          <div class="flex-1 flex-column-start-center">
            <div class="name">{{$t('account.label5')}}({{bitName}})</div>
            <div class="count">{{optionReportData.MonthOptionOrder.Amount || '0.00'}}</div>
          </div>
          <div class="flex-1 flex-column-end-center">
            <div class="name">{{$t('account.label6')}}({{bitName}})</div>
            <div class="count" :class="optionReportData.MonthOptionOrder.Profit ? ( optionReportData.MonthOptionOrder.Profit > 0 ? 'green' : 'red') : ''">{{optionReportData.MonthOptionOrder.Profit || '0.00'}}</div>
          </div>
        </div>
      </div>

      <div class="statistics-box small" v-if="modalType == 1">
        <div class="box-title">{{$t('account.label8')}}</div>
        <div class="flex today-static">
          <div class="flex-1 flex-column-start-center">
            <div class="name">{{$t('account.label5')}}({{bitName}})</div>
            <div class="count">{{optionReportData.LastMonthOptionOrder.Amount || '0.00'}}</div>
          </div>
          <div class="flex-1 flex-column-end-center">
            <div class="name">{{$t('account.label6')}}({{bitName}})</div>
            <div class="count" :class="optionReportData.LastMonthOptionOrder.Profit ? ( optionReportData.LastMonthOptionOrder.Profit > 0 ? 'green' : 'red') : ''">{{optionReportData.LastMonthOptionOrder.Profit || '0.00'}}</div>
          </div>
        </div>
      </div>

      <div class="flex-center-between search-line" v-if="modalType == '2'">
        <div class="flex-center" >
          <span>{{i18n.t('imitate.label4')}}</span>
        </div>
        <div>
          <Search v-model="form.keyword" :placeholder="i18n.t('imitate.label5')" @clear="clearSearch" @search="searchBit" @input="searchBit"></Search>
        </div>
      </div>

      <div class="bit-list rankList clear white-box" v-if="modalType == '2'">
        <template v-for="(item, i) in bitList">
          <div class="list clear rank flex-center-between"  :key="i">
            <div class="icon">
              <img :src="`${item.Currency.Logo}`" alt="">
            </div>
            <div class="flex-1">
              <div class="flex-center-between name">
                <div>
                  {{item.Currency.Name}}
                </div>
                <div>{{item.ContractUse}}</div>
              </div>
              <div class="flex-center-between desc">
                <div>{{item.Currency.Remark}}</div>
                <div >
                 ≈ {{item.ContractFree}}
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="tab-bar-outer">
      <div class="tab-bar space">
        <div class="tab flex-1" @click="back" :class="{active: tabIndex == 1}">
          <div class="icon">
            <img :src="homeUrl" alt="" >
          </div>
          <div class="title">{{i18n.t(`imitate.tab1`)}}</div>
        </div>

        <div class="flex-1"></div>

        <div class="tab flex-1" @click="showMenu">
          <div class="icon big">
            <img :src="tradeUrl" alt="" >
          </div>
          <div class="title">{{i18n.t(`imitate.tab3`)}}</div>
        </div>

        <div class="flex-1"></div>

        <div class="tab flex-1" @click="changeTab()" :class="{active: tabIndex == 2}">
          <div class="icon">
            <img :src="userUrl2" alt="" v-if="tabIndex == 2">
            <img :src="userUrl" alt="" v-else>
          </div>
          <div class="title">{{i18n.t(`imitate.tab2`)}}</div>
        </div>
      </div>
    </div>

    <div class="menu-modal" v-show="showMenuModal" @click="hideModal">
      <div class="modal-box small">
        <img :src="closeUrl" alt="" class="close">
        <div  class="menu flex-center-between"  v-for="(item, i) in menuList" :key="i" :class="menuIndex == i ? 'active' : ''" @click.stop="chooseMenu(i)">
          <div class="flex-center">
            <img :src="item.url" alt="">
            <span>{{item.name}}</span>
          </div>
          <div class="icon flex-center" v-show="menuIndex == i">
            <img :src="checkedUrl" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, Tabs, Tab, Search } from 'vant'
import topBar from '@/components/topBar'
import { imitateWallet } from '@/api/trade'
import { monetaryList } from '@/api/index'
import { optionReport } from '@/api/assest'
import tradePage from './trade'
export default {
  name: 'home',
  components: {
    topBar,
    Button,
    Tabs,
    Tab,
    Search,
    tradePage
  },
  data() {
    return {
      form: {
        keyword: ''
      },
      modalType: 1,
      tabIndex: 1,
      userType: 1,
      orderIndex: 0,
      homeUrl: require('../../assets/imgs/imitate-home.png'),
      homeUrl2: require('../../assets/imgs/imitate-home2.png'),
      userUrl: require('../../assets/imgs/imitate-assets.png'),
      userUrl2: require('../../assets/imgs/imitate-assets2.png'),
      tradeUrl: require('../../assets/imgs/tab/trade.png'),
      eyeUrl: require('../../assets/imgs/icon-eye.png'),
      eyeUrl2: require('../../assets/imgs/icon-eye2.png'),
      menuUrl1: require('../../assets/imgs/icon-transfer3.png'),
      menuUrl2: require('../../assets/imgs/icon-debt.png'),
      emptyUrl: require('../../assets/imgs/order-empty.png'),
      levelObj: {
        url1: require('../../assets/imgs/level1.png'),
        url2: require('../../assets/imgs/level2.png'),
      },
      userList: [
        {}, {}, {}
      ],
      followUserList: [
        {
          count: 123.33
        },
        {
          count: 433.33
        },
        {
          count: -23.33
        },
      ],
      showMoney: false,
      showMenuModal: false,
      userMoney: '0.00',
      bitList: [],
      closeUrl: require('../../assets/imgs/icon-close2.png'),
      checkedUrl: require('../../assets/imgs/icon-checked3.png'),
      menuIndex: 0,
      optionMoneyUse: '0.00',
      contractMoneyUse: '0.00',
      allRateList: [],
      bitName: 'USDT',
      optionReportData: {
        TodayOptionOrder: {},
        MonthOptionOrder: {},
        LastMonthOptionOrder: {},
      }
    }
  },
  watch: {
    $route(to, from) {
      if (to.meta.index < from.meta.index) {
        this.transitionName = 'slide-right'
      } else if (to.meta.index > from.meta.index) {
        this.transitionName = 'slide-left'
      }

      let name = to.name
      if (name != 'trade') {
        this.menuIndex = -1
      }
    }
  },
  computed: {
     moneyStr() {
      return this.showMoney ? parseFloat(this.modalType == 1 ? this.optionMoneyUse : this.contractMoneyUse).toFixed(4) : '****'
    },
    tabList() {
      return [`${this.$t('follow.order1')}(${1})`, this.$t('follow.order2'), this.$t('follow.order3'), this.$t('follow.order4')]
    },
    menuList() {
      return [
        {
          url: require('../../assets/imgs/trade3.png'),
          name: this.$t('common.trade3'),
        },
        {
          url: require('../../assets/imgs/trade4.png'),
          name: this.$t('common.trade4'),
        },
      ]
    }
  },
  mounted() {
    let bitName = localStorage.getItem('bitName')
    if (bitName) {
      this.bitName = bitName
      this.bitId = localStorage.getItem('bitId')
    }

    this.tabIndex = 1
    this.init()
    this.initRate()
  },
  methods: {
    initRate() {
			monetaryList().then(res => {
				this.allRateList = res.data.Items
			})
		},
    initOption() {
      optionReport().then(res => {
        this.optionReportData= res.data
      })
    },
    init() {
      let form = new FormData()
      form.append('current', 1)
      form.append('pageSize', 10)
      form.append('ShortName', 'usdt')
      imitateWallet(form).then(res => {
        let data = res.data.Items[0]
        if (data) {
          this.optionMoneyUse = parseFloat(data.OptionUse).toFixed(4) // 期权
          this.contractMoneyUse = parseFloat(data.ContractUse).toFixed(4) // 合约
        }
      })
    },
    changeTab() {
      this.tabIndex = 2
      this.menuIndex = -1
      this.initOption()
      document.body.style.background  = '#F6F7F8'
    },
    back() {
      // this.$router.go(-1)
      let name = sessionStorage.getItem('routeBak')
      let query = JSON.parse(sessionStorage.getItem('routeQuery'))
      console.log(111, name, query)
      this.$router.replace({
        name: name,
        query: query || {}
      })
    },
    changeMoneyType() {
      this.showMoney = !this.showMoney
    },
    toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    changeType(type) {
      this.userType = type
    },
    toDetail(data) {
      this.$router.push({
        name: 'followDetail'
      })
    },
    clearSearch() {
      this.form.keyword = ''
      this.bitList = [].concat(this.bitListBak)
    },
    searchBit() {
      this.bitList = this.bitListBak.filter(v => {
        return v.Currency.Name.toLowerCase().indexOf(this.form.keyword) > -1
      })
    },
    showMenu() {
      if (this.tabIndex == 2) {
        this.chooseMenu(0)
      } else {
        this.showMenuModal = true
      }
    },
    hideModal() {
      this.showMenuModal = false
    },
    chooseMenu(i) {
      this.modalType = i + 1
      this.tabIndex = 1
      this.menuIndex = i
      document.body.style.background  = '#FFFFFF'
      this.showMenuModal = false
    },
    resetBitMoney() {
      let money = this.modalType == 1 ? this.optionMoneyUse : this.contractMoneyUse
			let rate = 1
			let index = this.allRateList.findIndex(v => {
				return v.Name == this.localCurrency
			})
			if (index > -1) {
				rate = this.allRateList[index].Rate
			}
			return (money * rate).toFixed(4)
		}
  }
}
</script>